import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Unit } from '../../../helpers/unit';
import { setSelectedLoadIds, setLoadQueueNotes, inComplete, setIsNeedPlanterValues } from '../../../actions/load';
import { editLoad } from '../../../actions/equipment-group';
import LoadCardLeft from './LoadCardLeft';
import { useLoadQueueContext } from './context/LoadQueueContext';
import { getDisplayDate, getDisplayTime } from '../utils';
import { DISPLAY_DATETIME_FORMAT2 } from '../../../constants';
import { LoadNotePopup } from '../../LoadHistory/LoadNotePopup';
import { SeedNotePopup } from '../../seedHistory/SeedNotePopup';
import { LogisticsNotePopup } from '../../Logistics/LogisticsNotePopup';
import { getUserId } from '../../../helpers/session';
import { dateUTCToTimezone } from '../../../helpers/moment-ex';
import { Icon } from '../../widgets';
import LoadSample from '../../../constants/LoadSample';
import LoadSampleProfileTable from '../../../constants/LoadSampleProfileTable';
import { editSeedLoad } from '../../../actions/plan';
import MultiSelect from '../../../constants/MultiSelect';
import { saveScaleInfo } from '../../../actions/remote-scale';
import { validateCollections } from '../../../helpers/common';

const LoadCardOne = props => {
	const unit = Unit.getInstance();
	const dispatch = useDispatch();
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const timezoneIdentifier = useSelector(state => state.farm.currentFarm.timezone_identifier);
	const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
	const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
	const selectedLoadIds = useSelector(state => state.load.selectedLoadIds);
	const loadQueueType = useSelector(state => state.load.loadQueueType);
	const weightShortName = useSelector(state => state.user.settings.weightShortName);
	const scaleSocket = useSelector(state => state.scaleSocket);

	const { load, onChange, formDatas, fieldRegionOptions, sourceEGOptions, isApproveDataValid, isPlanterAllocation } = props;

	const [isChecked, setIsChecked] = useState(false);
	const [isEdited, setEdited] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [isSequenceEdited, setSequenceEdited] = useState(false);
	const [loadSequenceList, setLoadSequenceList] = useState((load.loadSequence && load.loadSequence.length > 0) ? sortedData(load.loadSequence, unit) : []);

	const [loadQueueData, setLoadQueueData] = useState({
		loadCapacity: unit.toWeight(load.loadCapacity, 2),
		loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2),
		estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2),
		offloadGeoShapeId: load.offloadGeoShapeId || null,
		offloadStorageLocationId: load.offloadStorageLocationId || "",
		tareWeight: load.tareWeight ? unit.toWeight(load.tareWeight, 2) : "",
		lightWeight: load.lightWeight ? unit.toWeight(load.lightWeight, 2) : "",
		pipe: load.pipe ? load.pipe : null,
		load_params: load.load_params ? load.load_params : null,
		fieldId: load.fieldGeoShapeId || ""
	});

	const { socketConneted, runningWeight, scaleAtStandStill, grossOrNet } = useMemo(() => {
		const { isConnected, scaleWeightInfo } = scaleSocket;
		const { weight: scaleWeight, scale_at_standstill, gross_or_net } = scaleWeightInfo;
		return { socketConneted: isConnected, runningWeight: scaleWeight, scaleAtStandStill: scale_at_standstill, grossOrNet: gross_or_net }
	}, [scaleSocket]);

	const [showModal, setShowModal] = useState({
		loadSample: false,
		loadSampleProfileTable: false
	});
	const [cancelling, setCancelling] = useState(false);


	const plantingQueueInputs = useSelector(state => state.load.plantingQueueInput);
	const loadQueueList = useSelector((state) => state.load.loadQueueList.data);
	const currentDate = moment().utc().format();

	// const [offloadStorageLocationList, setOffloadStorageLocationList] = useState([]);
	const { multiApporveData, editedLoadsById, setIsEdited } = useLoadQueueContext();
	let { load_params = {} } = loadQueueData;
	const [showError, setShowError] = useState(false);

	// const isSelected = useMemo(() => selectedLoadIds.indexOf(load.loadActivityId) >= 0,
	//     [selectedLoadIds, load.loadActivityId]);
	const isSelected = useMemo(() => {
		if ((selectedLoadIds.indexOf(load.loadActivityId) >= 0) && !isSequenceEdited && !isEdited) {
			return true
		}
		return false;
	}, [selectedLoadIds, load.loadActivityId, isSequenceEdited, isEdited])

	useEffect(() => {
		if (editedLoadsById[load.loadActivityId] && editedLoadsById[load.loadActivityId].loadCapacity)

			onChange(load.loadActivityId, {
				loadCapacity: unit.toWeight(load.loadCapacity, 2),
				tareWeight: unit.toWeight(load.tareWeight, 2),
				loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : 0,
			});

		setLoadQueueData({
			...loadQueueData, loadCapacity: unit.toWeight(load.loadCapacity, 2), tareWeight: unit.toWeight(load.tareWeight, 2),
			loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2), estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2)
		});
	}, [weightShortName]);

	useEffect(() => {
		if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) !isChecked && setIsChecked(true);
		else if (isChecked) setIsChecked(false);
	}, [selectedLoadIds]);

	useEffect(() => {
		if (!isChecked) {
			setLoadQueueData({
				loadCapacity: unit.toWeight(load.loadCapacity, 2),
				tareWeight: unit.toWeight(load.tareWeight, 2),
				lightWeight: load.lightWeight ? unit.toWeight(load.lightWeight, 2) : "",
				estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2),
				loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2),
				offloadGeoShapeId: load.offloadGeoShapeId || null,
				offloadStorageLocationId: load.offloadStorageLocationId || "",
				load_params: load.load_params ? load.load_params : null,
				fieldId: load.fieldGeoShapeId || ""
			});
		}
	}, [isChecked]);

	useEffect(() => {
		if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) {
			setLoadQueueData({ ...loadQueueData, ...multiApporveData });
			onChange(load.loadActivityId, multiApporveData);
		}
	}, [multiApporveData, selectedLoadIds]);

	const isAllowSample = useMemo(() => {
		if (farmSettings && farmSettings.seed_load_sample && farmSettings.seed_load_sample.visible && farmSettings.seed_load_sample.plan_type_ids) {
			const configPlanTypeIds = farmSettings.seed_load_sample.plan_type_ids;
			return configPlanTypeIds.length > 0 ? farmSettings.seed_load_sample.plan_type_ids.includes(planTypeId) : false;
		}
		return false;

	}, [farmSettings, planTypeId]);

	const isSeedPieceProfile = useMemo(() => {
		if (farmSettings && farmSettings.seed_piece_profile_sample && farmSettings.seed_piece_profile_sample.visible) {
			return farmSettings.seed_piece_profile_sample.visible;
		}
		return false

	}, [farmSettings]);

	const getWeight = useMemo(() => {
		const sequenceCapacity = (loadSequenceList.length > 0) ? loadSequenceList.reduce((a, b) => a + b.load_capacity, 0) : 0;
		const totalLoadCapacity = unit.toRoundOfWeight(load.loadCapacity);

		return (sequenceCapacity === 0 ? <span>  <span className='text-success'> {totalLoadCapacity}</span> {weightShortName}</span>
			: <span> <span className='text-success'>{(totalLoadCapacity - sequenceCapacity).toFixed(1)}</span> (of {totalLoadCapacity}) {weightShortName}</span>);
	}, [load, loadSequenceList]);

	const isDisabled = useMemo(() => {
		if (socketConneted) {
			if (!scaleAtStandStill) return true;
			else if (scaleAtStandStill && isSelected) {
				return false;
			}
			else if (isEdited) return false
			return true;
		}
		else if (!isPlanterAllocation && loadQueueData.fieldId) {
			if (load.fieldGeoShapeId !== loadQueueData.fieldId) return false;
			return !isEdited;
		} else if (!isPlanterAllocation) {
			return !isEdited;
		}
		return Object.values(plantingQueueInputs).some(input => !input);
	}, [socketConneted, loadQueueData, plantingQueueInputs, scaleAtStandStill, isSelected, isEdited]);

	const handleSelection = (id, isChecked) => {
		if (socketConneted) {
			if (selectedLoadIds.indexOf(id) >= 0) {
				selectedLoadIds.splice(selectedLoadIds.indexOf(id), 1);
				if (loadSequenceList && loadSequenceList.length === 1) {
					const existingSequence = (load.loadSequence && load.loadSequence.length > 0) ? sortedData(load.loadSequence, unit) : []
					setLoadSequenceList(existingSequence);
				}
			}
			else if (selectedLoadIds.length === 0 && scaleAtStandStill) {
				selectedLoadIds.push(id);
				const newGrossWeight = (grossOrNet && grossOrNet === 'G') ? runningWeight : loadQueueData.loadGrossWeight;
				const netWeight = (grossOrNet && grossOrNet === 'N') ? runningWeight : Number(newGrossWeight) -
					(Number(loadQueueData.tareWeight) + (load.lightWeight ? Number(unit.toWeight(load.lightWeight, 2)) : 0));

				let newLoadQueueData = { ...loadQueueData, loadCapacity: netWeight, loadGrossWeight: newGrossWeight };
				setLoadQueueData(newLoadQueueData);
				if (loadSequenceList && loadSequenceList.length === 1) {
					const updtedSequence = [...loadSequenceList].map((e) => ({
						...e, load_capacity: netWeight
					}));
					setLoadSequenceList(updtedSequence);
				}
			}
			dispatch(setSelectedLoadIds([...selectedLoadIds]));
		} else if (!isSequenceEdited) {
			if (selectedLoadIds.indexOf(id) >= 0) selectedLoadIds.splice(selectedLoadIds.indexOf(id), 1);
			else selectedLoadIds.push(id);
			setIsChecked(isChecked);
			if (selectedLoadIds && selectedLoadIds.length > 0) {
				for (let i = 0; i < selectedLoadIds.length; i++) {
					const selectedLoadDetails = loadQueueList.find((load) => load.loadActivityId === selectedLoadIds[i]);
					if (selectedLoadDetails && selectedLoadDetails.loadSequence && selectedLoadDetails.loadSequence.length > 0) {
						dispatch(setIsNeedPlanterValues(false));
						break;
					} else {
						dispatch(setIsNeedPlanterValues(true));
					}
				}
			}
			dispatch(setSelectedLoadIds([...selectedLoadIds]));
		}
	};

	const handleTextChange = (type, keyValue, value) => {
		setSequenceEdited(true);
		let inputValue = value ? value.toString().trim() : '';
		inputValue = (inputValue && type === 'number') ? Number(inputValue) : inputValue;

		const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
		loadParams[keyValue] = inputValue
		const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
		setDynamicInputsChanges(newLoadQueueData, loadParams);
		dispatch(setSelectedLoadIds([]));
	}

	const setDynamicInputsChanges = (newLoadQueueData, loadParams) => {
		setLoadQueueData(newLoadQueueData);
		onChange(load.loadActivityId, {
			loadCapacity: loadQueueData.loadCapacity ? loadQueueData.loadCapacity : 0,
			tareWeight: loadQueueData.tareWeight ? loadQueueData.tareWeight : 0,
			loadGrossWeight: loadQueueData.loadGrossWeight ? loadQueueData.loadGrossWeight : 0,
			load_params: { ...loadParams }
		});
		setEdited(true);
	}

	const handleInputChange = (type, keyValue, value, item, formName) => {
		setSequenceEdited(true);
		if (type === 'options') {
			item[keyValue] = (value && value.value) ? value.value : null;
			if (formName === 'field' && value && value.value) {
				let getFieldFata = fieldRegionOptions.find((field) => field.value === value.value);
				item['geo_shape_name'] = (getFieldFata && getFieldFata.label) ? getFieldFata.label : null;
				item['geo_shape_uuid'] = (value && value.value) ? value.value : null;
				item['geo_region_uuid'] = (getFieldFata && getFieldFata.regionId) ? getFieldFata.regionId : null;
			}
			if (formName === 'planter' && value && value.value) {
				let getPlanterData = sourceEGOptions.find((source) => source.value === value.value);
				item['target_equipment_group_name'] = getPlanterData ? getPlanterData.label : null;
			}
		} else {
			let inputValue = value ? value.toString() : '';
			inputValue = (type === 'string') ? inputValue.trim() : inputValue;
			inputValue = (type === 'number' && inputValue.trim() !== '') ? Number(inputValue) : inputValue;
			item[keyValue] = inputValue;

		}

		const updatedItem = {
			...item,
			modified_date: currentDate,
			modified_by: getUserId(),
			load_capacity: item.load_capacity ? item.load_capacity : 0,
		}
		let updatedSequence = [...loadSequenceList.filter((e) => e.sequence_id !== item.sequence_id), updatedItem]
		updatedSequence = updatedSequence.sort((a, b) => a.sequence - b.sequence);
		setLoadSequenceList(updatedSequence);
		// props.actions.setSelectedLoadIds([]);
	}

	const saveLoadSample = (saveLoad) => {
		const updatedKey = (showModal.loadSampleProfileTable) ? 'seed_piece_profile' : 'seed_sample';
		dispatch(editSeedLoad(saveLoad, ((isSaved, params) => {
			if (isSaved) {
				dispatch(setLoadQueueNotes(load, { [updatedKey]: params[updatedKey] }));
			}
		})))
	}
	const handleSelect = (options, id) => {
		setSequenceEdited(true);
		const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
		loadParams[id] = (options && options.value) ? options.value : null;
		const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
		setLoadQueueData(newLoadQueueData);
		setDynamicInputsChanges(newLoadQueueData, loadParams);
		dispatch(setSelectedLoadIds([]));
	}

	const [selectedOptions, setSelectedOptions] = useState([]);

	const handleMultiSelectChange = (options, id) => {
		setSequenceEdited(true);
		const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
		loadParams[id] = options ? options.map(option => option.value) : [];
		const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
		setLoadQueueData(newLoadQueueData);
		setDynamicInputsChanges(newLoadQueueData, loadParams);
		dispatch(setSelectedLoadIds([]));
		setSelectedOptions(options);
	};

	const handleSelectDropdown = (options, id) => {
		const selectedValue = (options && options.value) ? options.value : null;
		const newLoadQueueData = { ...loadQueueData, [id]: selectedValue };
		setLoadQueueData(newLoadQueueData);
		setEdited(true);
	};

	const getDefaultSequence = ({ targetEgId, loadActivityId, loadWeight, fieldShapeId, fieldRegionId }) => {
		const defaultSequence = {
			sequence: 1,
			sequence_id: Date.now(),
			load_activity_uuid: loadActivityId,
			source_equipment_group_uuid: targetEgId,
			target_equipment_group_uuid: null,
			load_capacity: loadWeight ? unit.fromWeight(loadWeight, 2) : 0,
			geo_region_uuid: fieldRegionId,
			geo_shape_uuid: fieldShapeId,
			type: 1,
			status_id: 1,
			latitude: null,
			longitude: null,
			created_date: moment().utc().format(),
			created_by: getUserId(),
			modified_date: null,
			modified_by: null
		}
		return defaultSequence;
	}

	const handleSave = () => {
		const isValid = checkValidation();
		if (!isValid) return;
		let { loadCapacity, loadGrossWeight, tareWeight, load_params, fieldId, lightWeight } = loadQueueData;
		const { targetEquipmentGroupId: targetEgId, loadActivityId } = load;

		if (socketConneted || !isPlanterAllocation) {
			if (load.light_weight !== loadQueueData.lightWeight) {
				loadCapacity = Number(loadGrossWeight) - (Number(tareWeight) + (lightWeight ? Number(lightWeight) : 0));
			}
			let updatedData = {};
			setIsSaving(true);
			let params = {
				farm_uuid: farmId,
				load_activity_uuid: load.loadActivityId,
				load_capacity: loadCapacity ? unit.fromWeight(loadCapacity, 2) : 0,
				load_gross_weight: loadGrossWeight ? unit.fromWeight(loadGrossWeight, 2) : 0,
				tare_weight: tareWeight ? unit.fromWeight(tareWeight) : 0,
				light_weight: lightWeight ? unit.fromWeight(lightWeight, 2) : 0,
				last_modified_at: moment.utc().tz(timezoneIdentifier).format(),
				is_load_queue_edit: true,
				load_params: load_params ? load_params : null,
				planTypeId
			};
			let fieldData = null;
			if (fieldId) {
				fieldData = fieldRegionOptions.find((field) => field.value === fieldId);
			}
			if (!isPlanterAllocation && fieldId) {
				if (fieldData && fieldData.regionId && fieldData.value) {
					params["field_geo_shape_uuid"] = fieldData.value;
					params["field_geo_region_uuid"] = fieldData.regionId;
					updatedData['fieldGeoShapeId'] = fieldData.value;
				}
			}

			if (!isPlanterAllocation && loadSequenceList && loadSequenceList.length === 0 && fieldId) {
				fieldData = fieldRegionOptions.find((field) => field.value === fieldId);
				const fieldShapeId = fieldData.value
				const fieldRegionId = fieldData.regionId;

				const defaultSequence = getDefaultSequence({ targetEgId, loadActivityId, loadWeight: loadCapacity, fieldShapeId, fieldRegionId });
				params['load_sequence'] = [defaultSequence];
			}

			if (loadSequenceList && loadSequenceList.length === 1 /* && isPlanterAllocation */) {
				const updtedSequence = [...loadSequenceList].map((e) => (
					{
						...e,
						load_capacity: (loadCapacity) ? unit.fromWeight(loadCapacity, 2)
							: (e.load_capacity ? unit.fromWeight(e.load_capacity, 2) : 0),
						geo_region_uuid: !isPlanterAllocation ? (fieldData && fieldData.regionId ?
							fieldData.regionId : null) : e.geo_region_uuid,
						geo_shape_uuid: !isPlanterAllocation ? (fieldData && fieldData.value ?
							fieldData.value : null) : e.geo_shape_uuid

					}));
				params["load_sequence"] = [...updtedSequence];
			}
			updatedData = {
				...updatedData,
				loadCapacity: params.load_capacity, loadGrossWeight: params.load_gross_weight,
				tareWeight: params.tare_weight, load_params, lightWeight: params.light_weight
			};
			dispatch(setLoadQueueNotes(load, updatedData));
			saveSequence(params);
			setEdited(false);
		} else {
			setIsSaving(true);
			const lastSeqId = loadSequenceList.length > 0 ? loadSequenceList.sort((a, b) => b.sequence - a.sequence)[0].sequence : 0;

			const sequence = {
				sequence: lastSeqId + 1,
				sequence_id: Date.now(),
				load_activity_uuid: load.loadActivityId,
				source_equipment_group_uuid: load.targetEquipmentGroupId,
				target_equipment_group_uuid: plantingQueueInputs.planterId,
				load_capacity: plantingQueueInputs.loadCapacity ? unit.fromWeight(plantingQueueInputs.loadCapacity, 2) : 0,
				geo_region_uuid: plantingQueueInputs.fieldRegionId,
				geo_shape_uuid: plantingQueueInputs.fieldShapeId,
				type: 1,
				status_id: 1,
				latitude: null,
				longitude: null,
				created_date: currentDate,
				created_by: getUserId(),
				modified_date: null,
				modified_by: null
			}

			const mergedData = [...loadSequenceList].map((e) => ({ ...e, load_capacity: e.load_capacity ? unit.fromWeight(e.load_capacity, 2) : 0 }));

			const params = {
				farm_uuid: farmId,
				load_activity_uuid: load.loadActivityId,
				load_sequence: [...mergedData, sequence],
				planTypeId: planTypeId,
				load_params: load_params ? load_params : null,
			};
			dispatch(setLoadQueueNotes(load, { loadSequence: params.load_sequence }));
			setLoadSequenceList(sortedData(params.load_sequence, unit));
			saveSequence(params);
		}
	};


	const handleUpdate = () => {
		const { load_params } = loadQueueData;
		const isValid = checkValidation();
		if (!isValid) return;

		setIsSaving(true);
		const data = {
			farm_uuid: farmId,
			load_activity_uuid: load.loadActivityId,
			load_sequence: [...loadSequenceList].map((e) => {
				return {
					...e,
					load_capacity: e.load_capacity ? unit.fromWeight(e.load_capacity, 2) : 0
				}
			}),
			planTypeId: planTypeId,
			load_params: load_params ? load_params : null
		}
		dispatch(setLoadQueueNotes(load, { loadSequence: data.load_sequence }));
		saveSequence(data);
	};

	const deleteSequence = (sequenceId) => {
		setIsSaving(true);
		const filteredSequence = [...loadSequenceList].filter((e) => e.sequence_id !== sequenceId);
		const data = {
			farm_uuid: farmId,
			load_activity_uuid: load.loadActivityId,
			load_sequence: [...filteredSequence].map((e) => {
				return {
					...e,
					load_capacity: e.load_capacity ? unit.fromWeight(e.load_capacity, 2) : 0
				}
			}),
			planTypeId: planTypeId
		}
		saveSequence(data);
		dispatch(setLoadQueueNotes(load, { loadSequence: filteredSequence }));
		setLoadSequenceList(filteredSequence);
	}

	const saveSequence = (data) => {
		dispatch(editLoad(data, (isSaved => {
			if (isSaved) {
				if (socketConneted) {
					acknowledgeScale(data);
				};
				setIsSaving(false);
				setEdited(false);
				setIsEdited(false);
				setSequenceEdited(false);
				dispatch(setSelectedLoadIds([]));
				// getLoadList();
			}
		})));
	}

	const checkValidation = () => {
		const { load_params } = loadQueueData;
		let isValid = true;
		if (formDatas && formDatas.length > 0) {
			for (let i = 0; i < formDatas.length; i++) {
				const formData = formDatas[i];
				if (!formData) continue;
				if (formData.required) {
					if (!load_params || (load_params && !load_params[formData.key])) {
						isValid = false;
						setShowError(true);
						break;
					}
				}

				if (load_params && load_params[formData.key] && formData.hasOwnProperty('rules') &&
					formData.rules.hasOwnProperty('max_length')
					&& load_params[formData.key].toString().trim().length > formData.rules.max_length) {
					isValid = false;
					setShowError(true);
					break;
				}
			}
		}
		return isValid;
	}

	const handleShowModal = (type, show) => setShowModal({ ...showModal, [type]: show });

	const handleCancel = () => {
		setCancelling(true);

		const params = {
			farm_uuid: load.farmId,
			source_equipment_group_uuid: load.sourceEquipmentGroupId,
			target_equipment_group_uuid: load.targetEquipmentGroupId,
			load_activity_uuid: load.loadActivityId,
			planTypeId
		};
		dispatch(inComplete(params, (isSuccess) => {
			!isSuccess && setCancelling(false);
		}));
	};

	let loadGrossWeight = 0;
	const handleChange = (name, value) => {
		let newLoadQueueData = { ...loadQueueData };
		let newNetWeight = 0;
		const inputValue = value.toString().trim();
		if (name === "loadGrossWeight") {
			let netWeight = 0;
			if (inputValue.length === 0) {
				setEdited(false);
			}
			else {
				if (Number(unit.toWeight(load.loadGrossWeight, 2)) === Number(value)) setEdited(false);
				else setEdited(true);
			}

			loadGrossWeight = value ? Number(value) : 0;
			netWeight = Number(loadGrossWeight) - (Number(loadQueueData.tareWeight) + (loadQueueData.lightWeight ? loadQueueData.lightWeight : 0));
			newLoadQueueData = { ...newLoadQueueData, loadCapacity: netWeight, loadGrossWeight: loadGrossWeight };
			newNetWeight = netWeight;
		} else if (name === "lightWeight") {
			let lightWeight = Number(value);
			if (inputValue.length === 0) {
				setEdited(false);
				newLoadQueueData = { ...newLoadQueueData, lightWeight: "" };
			} else {
				if (Number(unit.toWeight(load.lightWeight, 2)) === lightWeight) setEdited(false);
				else setEdited(true);
				const loadCapacity = Number(loadQueueData.loadGrossWeight) - (Number(loadQueueData.tareWeight) + (lightWeight ? Number(lightWeight) : 0));
				newLoadQueueData = { ...newLoadQueueData, lightWeight, loadCapacity };
				newNetWeight = loadCapacity;
			}
		}
		if (loadSequenceList && loadSequenceList.length === 1) {
			const updtedSequence = [...loadSequenceList].map((e) => ({
				...e, load_capacity: newNetWeight
			}));
			setLoadSequenceList(updtedSequence);
		}
		setLoadQueueData(newLoadQueueData);
	};

	const acknowledgeScale = (data) => {
		if (socketConneted && data) {
			const { targetEquipmentGroupId } = load;
			const params = {
				...scaleSocket.scaleWeightInfo,
				"equipment_group_uuid": targetEquipmentGroupId,
				"modified_by_uuid": getUserId()
			}
			let isWeightDiff = false;
			const gross = unit.toWeight(data.load_gross_weight, 2);
			const net = unit.toWeight(data.load_capacity, 2);
			if (grossOrNet && grossOrNet === 'G' && runningWeight !== gross) {
				params["weight"] = gross;
				isWeightDiff = true;
			} else if (grossOrNet && grossOrNet === 'N' && runningWeight !== net) {
				params["weight"] = net;
				isWeightDiff = true;
			}
			if (isWeightDiff) {
				params["original_data"] = scaleSocket.scaleWeightInfo
			}
			dispatch(saveScaleInfo(params));
		}
	}

	return <div className="d-flex">
		<div className={`load-card planting-queue-card queue-type ${isSelected ? "queue_selected" : ""} ${loadQueueType === 2 ? 'mt-3 w-100' : ''}`} id={load.loadActivityId}>
			<LoadCardLeft
				load={load}
				unit={unit}
				settings={props.settings}
				loadQueueData={loadQueueData}
				weightShortName={weightShortName}
			/>
			<div className="load-card-main">
				<Row className="load-card-header m-0 justify-content-between px-2" onClick={() => (!isSequenceEdited && !isEdited && loadQueueType !== 2) && handleSelection(load.loadActivityId)} >
					<Col className={`dateTime-col ${loadQueueType === 2 ? 'col-7 pr-0' : 'col-8'}`}>
						<div className='load-date'>
							<div className="date">{getDisplayDate(load.loadDateTz)}</div>
							<div className="time">
								{getDisplayTime(load.startDateTz)}
							</div>
							{load.startDateTz && <span>-</span>}
							<div className="time">
								{getDisplayTime(load.endDateTz)}
							</div>
						</div>
					</Col>
					<Col /* onClick={(e) => e.stopPropagation()} */ className={`col-4 d-flex cursor-default justify-content-end ${loadQueueType === 2 ? 'col-5 pl-0' : 'col-4'}`}
						style={{
							fontSize: "19px",
							textAlign: "end",
							gap: "10px",
							cursor: (isEdited || selectedLoadIds.length > 0) ? "not-allowed" : "pointer"
						}}>

						{isSeedPieceProfile && <div>
							<Icon
								title="Load Sample Profile Table"
								onClick={() => handleShowModal("loadSampleProfileTable", true)}
								className="fa fa-wpforms mx-1 cursor-pointer"
								ariaHidden="true" />
						</div>}

						{isAllowSample && <div>
							<Icon
								title="Load Sample"
								onClick={() => handleShowModal("loadSample", true)}
								className="fa fa-flask mx-1 cursor-pointer"
								ariaHidden="true" />
						</div>}

						<GetLoadNotes planTypeId={planTypeId} isQueue={true} load={{ ...load, load_activity_uuid: load.loadActivityId }} />
						{loadQueueType === 2 ?
							<Button
								size="sm"
								title="Move To Queue"
								variant="danger"
								disabled={cancelling}
								className="btn-load-queue float-right"
								onClick={handleCancel}
							>
								{cancelling ? "Moving..." : "Move To Queue"}
							</Button>
							: (!isSequenceEdited || !isPlanterAllocation || (!isPlanterAllocation && isSequenceEdited)) ? <Button className='btn-sm'
								// style={{ cursor: (!isEdited || selectedLoadIds.length > 0) ? "not-allowed" : "pointer" }}
								disabled={isDisabled || (!socketConneted && selectedLoadIds.length > 0)}
								onClick={() => handleSave()}>
								{isSaving ? 'Saving' : 'Save'}
							</Button> :
								<Button className='btn-sm'
									// style={{ cursor: (!isEdited || selectedLoadIds.length > 0) ? "not-allowed" : "pointer" }}
									// disabled={!isEdited || selectedLoadIds.length > 0}
									onClick={() => handleUpdate()}>
									{isSaving ? 'Updating' : 'Update'}
								</Button>
						}

					</Col>
				</Row>
				<Row className="load-card-detail-1 m-0 mx-2">
					<Col xs={6}>
						<div className="label">Implement</div>
						<div className="text">{load.sourceEquipmentGroupName ? load.sourceEquipmentGroupName : "Unknown"}</div>
					</Col>
					{!isPlanterAllocation && <Col xs={6}>
						<div className="label">Offload (Load Origin)</div>
						<div className="text">{load.offloadGeoShapeName ? load.offloadGeoShapeName : "N/A"}</div>
					</Col>}

					{(socketConneted || !isPlanterAllocation) ?
						<>
							<Col xs={6}>
								<div className="label">{`Light Weight (${weightShortName})`}</div>
								<input
									type="number"
									className="input-type"
									value={loadQueueData.lightWeight}
									onChange={e => handleChange("lightWeight", e.target.value)} />
							</Col>
							<Col xs={6}>
								<div className="label">{`Load Confirmation (${weightShortName})`}
									<span className='text-danger required'>*</span>
								</div>
								<input
									type="number"
									className="input-type"
									value={loadQueueData.loadGrossWeight}
									style={{ width: "90%" }}
									onChange={e => handleChange("loadGrossWeight", e.target.value)} />

								{(isEdited || load.lastModifiedAt) && <span className="isEdited ml-1">
									<i className='fa fa-check' title={load && load.lastModifiedAt ? moment.utc(load.lastModifiedAt).format("DD MMM YYYY hh:mm A") : ""} style={{ color: "green" }} />
								</span>}
							</Col>

							{!isPlanterAllocation && <Col xs={6}>
								<Form.Label htmlFor="Field">Field (Load Destination)</Form.Label>
								<Form.Select
									options={fieldRegionOptions}
									id="fieldId"
									placeholder={`Select Field`}
									name="fieldId"
									onChange={(e) => handleSelectDropdown(e, "fieldId")}
									value={loadQueueData.fieldId}
								></Form.Select>
							</Col>}
						</>
						:
						<Col>
							<div className="label">Total Load Capacity</div>
							<div className="text">{load.loadCapacity ? getWeight : "N/A"}</div>
						</Col>}
					<Col xs={6}>
						<div className="label">Scale Ticket</div>
						<div className="text">{validateCollections(load.scaleTicket) ? load.scaleTicket.toString() : "N/A"}</div>
					</Col>
				</Row>
				{isPlanterAllocation ?
					<div className={`my-2 load-sequence-card`}>
						{loadSequenceList.map((item) => {
							const egID = item.target_equipment_group_uuid ? item.target_equipment_group_uuid : "";
							return (
								<Row className='d-flex align-items-center load_sequence_row flex-direction-column mb-2 mx-0' key={item.sequence_id}>
									<Col lg={12}>
										<div className='d-flex w-100 justify-content-between'>
											<p className='mb-0 load_sequence_date'>{dateUTCToTimezone(item.modified_date ? item.modified_date : item.created_date, timezoneIdentifier).format(DISPLAY_DATETIME_FORMAT2)}</p>
											{!socketConneted && loadQueueType !== 2 && selectedLoadIds.length === 0 &&
												<div className='cross_icon' onClick={() => deleteSequence(item.sequence_id)}>
													<i className='fa fa-close'></i>
												</div>
											}

										</div>
									</Col>
									<Col>
										<Form.Select
											value={item.geo_shape_uuid ? item.geo_shape_uuid : ""}
											placeholder="Field"
											options={fieldRegionOptions}
											disabled={socketConneted || loadQueueType === 2 || selectedLoadIds.length > 0}
											onChange={(e) => handleInputChange('options', 'geo_shape_uuid', e, item, 'field')}
										/>
									</Col>
									<Col>
										<Form.Select
											value={egID}
											placeholder="planter"
											options={sourceEGOptions}
											disabled={socketConneted || loadQueueType === 2 || selectedLoadIds.length > 0}
											onChange={(e) => handleInputChange('options', 'target_equipment_group_uuid', e, item, 'planter')}
										/>
									</Col>
									<Col style={{ minWidth: '120px', flexGrow: '0' }}>
										<input
											type="number"
											className="input-type"
											value={item.load_capacity ? item.load_capacity : null}
											onChange={(e) => handleInputChange('number', 'load_capacity', e.target.value, item)}
											disabled={socketConneted || loadQueueType === 2 || selectedLoadIds.length > 0}
										// max={unit.toWeight(load.estimatedLoadCapacity, 2)}
										// min={0}
										// onChange={e => handleChange("tareWeight", e.target.value)}
										/>
										{/* <Form.Control
                                        type="text"
                                        placeholder="Capacity"
                                        className='input-type'
                                        value={item.load_capacity ? item.load_capacity : null}
                                    // disabled={selectedLoadIds && selectedLoadIds.length === 0}  /> */}

									</Col>
									{/*   <p>{item.source_equipment_group_name ? item.source_equipment_group_name : "Unknown"}</p>
                                <p>{item.geo_shape_name ? item.geo_shape_name : "Unknown"}</p>
                                <p>{item.load_capacity ? item.load_capacity : "0"}</p> */}
								</Row>
							)
						})}


					</div> : null}
				<Row className="load-card-detail-1 m-0 mx-2 my-2 pr-2 align-items-center">
					{formDatas && formDatas.length ?
						formDatas.map(e => {
							const keyValue = e.key;
							const value = load_params ?
								load_params.hasOwnProperty(keyValue) ? load_params[keyValue] : null : null;

							const multipleValues = e.isMulti && e.default_values && Array.isArray(e.default_values)
								? e.default_values.map(value => ({
									label: value,
									value: value,
								}))
								: []

							const FinalValue = (e.isMulti && multipleValues && multipleValues.length > 0) && e.options.filter((e) =>
								multipleValues.some((item) => item.value === e.value)
							)
							const defaultValues = load_params && load_params.hasOwnProperty(keyValue)
								? (keyValue === 'load_debris' && Array.isArray(load_params[keyValue]) && load_params[keyValue].length > 0)
									? load_params[keyValue].map(value => ({
										label: value,
										value: value,
									}))
									: FinalValue
								: FinalValue

							return (
								(e.type && e.type === 'multiselect' && e.visible && e.isMulti) ?
									<Col className='col-6' key={keyValue}>
										<Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
											{(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
										<MultiSelect
											closeMenuOnSelect={false}
											defaultValue={defaultValues}
											isMulti={true}
											isClearable={true}
											placeholder={e.label}
											value={selectedOptions}
											options={e.options}
											designType="checkbox"
											onChange={(e) => handleMultiSelectChange(e, keyValue)}
										/>
										{(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value) ?
											<small className="form-text text-error">{e.label} is required.</small> : null}
									</Col> :
									(e.type && e.type === 'options' && e.visible && e.showInLoadQueue) ?
										<Col className='col-6' key={keyValue}>
											<Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
												{(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
											<Form.Select
												options={e.options}
												id={keyValue}
												defaultValue={value}
												placeholder={`Select ${e.label}`}
												name={keyValue}
												onChange={(e) => handleSelect(e, keyValue)}
												value={value ? value : e.default_value ? e.default_value : ''}
												disabled={loadQueueType === 2 || selectedLoadIds.length > 0}
											/>

											{(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value) ?
												<small className="form-text text-error">{e.label} is required.</small> : null}
										</Col>
										:
										((e.type && e.visible && e.showInLoadQueue) && (e.type === 'text' || e.type === 'number')) ?
											<Col className='col-6' key={keyValue}>
												<Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
													{(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
												<input
													type={e.type}
													className="input-type"
													value={value ? value : ''}
													disabled={loadQueueType === 2 || selectedLoadIds.length > 0}
													onChange={i => handleTextChange(e.type, keyValue, i.target.value)} />

												{(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value)
													? <small className="form-text text-error">{e.label} is required.</small> : null}

												{(value && e.rules && e.rules.hasOwnProperty('max_length')
													&& (value.length > e.rules.max_length)) ?
													<small className="form-text text-error">Length can not exceed {e.rules.max_length}.</small> : null}
											</Col>
											: null
							)
						}
						) : null}
				</Row>
			</div>
		</div>
		{
			loadQueueType !== 2 && <div className="select-input">
				<div className="checkmark-container">
					<input
						type="checkbox"
						checked={isSelected}
						onChange={(e) => handleSelection(load.loadActivityId, e.target.value)}
					/>
					<span className={`checkmark`}></span>
				</div>
			</div>
		}

		{
			showModal.loadSample && <LoadSample
				show={showModal.loadSample}
				onHide={() => setShowModal({ ...showModal, loadSample: false })}
				load={{ ...load, load_activity_uuid: load.loadActivityId, farm_uuid: load.farmId }}
				farmId={farmId}
				saveSample={saveLoadSample}
			/>
		}
		{
			showModal.loadSampleProfileTable && <LoadSampleProfileTable
				show={showModal.loadSampleProfileTable}
				onHide={() => setShowModal({ ...showModal, loadSampleProfileTable: false })}
				load={{ ...load, load_activity_uuid: load.loadActivityId, farm_uuid: load.farmId }}
				farmId={farmId}
				saveSample={saveLoadSample}
			/>
		}
	</div >;
};

const GetLoadNotes = (props) => {
	const { planTypeId } = props;
	if (planTypeId && planTypeId === 2) {
		return (<SeedNotePopup {...props} />);
	} else if (planTypeId && planTypeId === 5) {
		return (<LogisticsNotePopup {...props} />);
	} else {
		return (<LoadNotePopup {...props} />);
	}
}

const sortedData = (data, unit) => {
	return data.map((e) => ({ ...e, load_capacity: e.load_capacity ? unit.toWeight(e.load_capacity, 2) : 0 })).sort((a, b) => a.sequence - b.sequence);
}

export default LoadCardOne;